<template>
  <div
    class="wrap wrap_layout request is-overwrap has-side"
    :class="{ 'show-side': showSideNav }"
  >
    <!-- Page content -->
    <div class="content container-fluid has-no-left-padding">
      <div class="btn_consignee01">
        <a href="#" @click.prevent="startNewHandler" class="btn btn-warning"
          >新規お届け先登録</a
        >
      </div>
      <!-- タブボタン部分 -->
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="changeSlugHandler(null)"
            class="nav-link"
            :class="{ active: !this.slug }"
            >全件</a
          >
        </li>
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="changeSlugHandler('a')"
            class="nav-link"
            :class="{ active: this.slug === 'a' }"
            >ア</a
          >
        </li>
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="changeSlugHandler('k')"
            class="nav-link"
            :class="{ active: this.slug === 'k' }"
            >カ</a
          >
        </li>
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="changeSlugHandler('s')"
            class="nav-link"
            :class="{ active: this.slug === 's' }"
            >サ</a
          >
        </li>
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="changeSlugHandler('t')"
            class="nav-link"
            :class="{ active: this.slug === 't' }"
            >タ</a
          >
        </li>
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="changeSlugHandler('n')"
            class="nav-link"
            :class="{ active: this.slug === 'n' }"
            >ナ</a
          >
        </li>
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="changeSlugHandler('h')"
            class="nav-link"
            :class="{ active: this.slug === 'h' }"
            >ハ</a
          >
        </li>
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="changeSlugHandler('m')"
            class="nav-link"
            :class="{ active: this.slug === 'm' }"
            >マ</a
          >
        </li>
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="changeSlugHandler('y')"
            class="nav-link"
            :class="{ active: this.slug === 'y' }"
            >ヤ</a
          >
        </li>
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="changeSlugHandler('r')"
            class="nav-link"
            :class="{ active: this.slug === 'r' }"
            >ラ</a
          >
        </li>
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="changeSlugHandler('w')"
            class="nav-link"
            :class="{ active: this.slug === 'w' }"
            >ワ</a
          >
        </li>
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="changeSlugHandler('az')"
            class="nav-link"
            :class="{ active: this.slug === 'az' }"
            >A-Z</a
          >
        </li>
      </ul>

      <!--タブのコンテンツ部分-->
      <div class="tab-content">
        <div class="tab-pane active">
          <div class="text-right mb20">
            <a
              href="#"
              @click.prevent="closeDeliveryDataSearchHandler"
              class="btn btn-primary"
              ><i class="fa fa-arrow-left" aria-hidden="true"></i>
              {{ backButtonLabel }}</a
            >
          </div>

          <div class="row_search mb20">
            <label
              >会社名：<input
                type="text"
                class="form-control"
                v-model="inputDlcompanyNa"
            /></label>
            <label
              >支店・工場名：<input
                type="text"
                class="form-control"
                v-model="inputDlcompanysubNa"
            /></label>
            <button class="btn btn-request" @click.prevent="applyFilter">
              検索
            </button>
          </div>

          <div class="mb-3 d-flex justify-content-end">
            <bs-pagination
              :page.sync="page"
              :per-page="per_page"
              :number="filiteredDataLength"
            ></bs-pagination>
          </div>

          <div class="table-responsive">
            <table
              class="table table-bordered bg-white tbl_request01 tbl_sample01"
            >
              <thead>
                <tr class="bg-tbl-head text-white">
                  <th class="is-width-auto">修正・削除依頼</th>
                  <th>会社名</th>
                  <th>支店・工場名</th>
                  <th>住所</th>
                  <th>TEL</th>
                  <th class="is-width-auto"></th>
                </tr>
              </thead>
              <tbody>
                <delivery-data-search-row
                  v-for="deliveryData in filteredPageList"
                  :key="deliveryData.row_no"
                  :selectedCd="selectedCd"
                  :delivery-data="deliveryData"
                  @select="selectDeliveryDataHandler"
                  @edit="startEditHandler"
                  @delete="startDeleteHandler"
                ></delivery-data-search-row>
              </tbody>
            </table>
          </div>

          <div class="mt-3 d-flex justify-content-end">
            <bs-pagination
              :page.sync="page"
              :per-page="per_page"
              :number="filiteredDataLength"
            ></bs-pagination>
          </div>
        </div>
        <!-- tab-pane -->
      </div>
    </div>

    <delivery-data-edit-modal
      v-if="is_edit"
      :deliveryData="editDeliveryData"
      @close="closeEditModalHandler"
      @edited="editDeliveryInfoHandler"
    ></delivery-data-edit-modal>
    <delivery-data-delete-modal
      v-if="is_delete"
      :deliveryData="deleteDeliveryData"
      @close="closeDeleteModalHandler"
      @deleted="deleteDeliveryInfoHandler"
    ></delivery-data-delete-modal>

    <delivery-data-new
      v-if="is_new"
      @added="addDeliverInfoHandler"
      @close="closeNewPageHandler"
    ></delivery-data-new>
  </div>
</template>

<script>
// Store
import { store as BootstrapStore } from "../../../store/Bootstrap";

// Components
import DeliveryDataSearchRow from "./Row.vue";
import DeliveryDataEditModal from "./EditModal.vue";
import DeliveryDataDeleteModal from "./DeleteModal.vue";
import DeliveryDataNew from "./New.vue";

export default {
  components: {
    DeliveryDataSearchRow,
    DeliveryDataEditModal,
    DeliveryDataDeleteModal,
    DeliveryDataNew
  },

  data() {
    return {
      // FilterParam
      inputDlcompanyNa: "",
      inputDlcompanysubNa: "",
      filterDlcompanyNa: "",
      filterDlcompanysubNa: "",
      slug: null,

      // Pagination
      page: 1,
      per_page: 200,

      // Edit
      is_edit: false,
      editDeliveryData: {},

      // Delete
      is_delete: false,
      deleteDeliveryData: {},

      // New
      is_new: false
    };
  },

  props: {
    selectedCd: { type: String, required: true },
    deliveryDataList: { type: Array, required: true },
    backButtonLabel: { type: String, required: true }
  },
  computed: {
    showSideNav() {
      return BootstrapStore.showSideNav;
    },
    filiteredData() {
      const slugList = this.deliveryDataList.filter(row => {
        if (this.slug) {
          let exp;

          switch (this.slug) {
            case "a":
              exp = new RegExp("^[ア-オｱ-ｵ]");
              break;
            case "k":
              exp = new RegExp("^[カ-コｶ-ｺ]");
              break;
            case "s":
              exp = new RegExp("^[サ-ソｻ-ｿ]");
              break;
            case "t":
              exp = new RegExp("^[タ-トﾀ-ﾄ]");
              break;
            case "n":
              exp = new RegExp("^[ナ-ノﾅ-ﾉ]");
              break;
            case "h":
              exp = new RegExp("^[ハ-ホﾊ-ﾎ]");
              break;
            case "m":
              exp = new RegExp("^[マ-モﾏ-ﾓ]");
              break;
            case "y":
              exp = new RegExp("^[ヤ-ヨﾔ-ﾖ]");
              break;
            case "r":
              exp = new RegExp("^[ラ-ロﾗ-ﾛ]");
              break;
            case "w":
              exp = new RegExp("^[ワ-ンﾜ-ﾝ]");
              break;
            case "az":
              exp = new RegExp("^[a-zA-Z]");
              break;
          }

          return (row.dlcompanykana_na || "").match(exp);
        }

        return true;
      });

      return slugList
        .filter(row => {
          if (
            this.filterDlcompanyNa !== "" &&
            !this.$utility.regExpMatch(row.dlcompany_na, this.filterDlcompanyNa)
          ) {
            return false;
          }

          if (
            this.filterDlcompanysubNa !== "" &&
            !this.$utility.regExpMatch(
              row.dlcompanysub_na,
              this.filterDlcompanysubNa
            )
          ) {
            return false;
          }

          return true;
        })
        .sort((a, b) => {
          const aName = a.dlcompanykana_na;
          const bName = b.dlcompanykana_na;

          if (aName < bName) {
            return -1;
          } else if (aName > bName) {
            return 1;
          }

          return 0;
        });
    },
    filiteredDataLength() {
      return this.filiteredData.length;
    },
    filteredPageList() {
      const from = (this.page - 1) * this.per_page;
      const to = from + this.per_page;
      return this.filiteredData.slice(from, to);
    }
  },
  methods: {
    applyFilter() {
      this.page = 1;
      this.filterDlcompanyNa = this.inputDlcompanyNa;
      this.filterDlcompanysubNa = this.inputDlcompanysubNa;
    },
    changeSlugHandler(slug) {
      this.page = 1;
      this.slug = slug;
    },
    closeDeliveryDataSearchHandler() {
      this.$emit("close");
    },
    selectDeliveryDataHandler(deliveryData) {
      this.$emit("select", deliveryData);
      this.closeDeliveryDataSearchHandler();
    },

    // New
    startNewHandler() {
      this.is_new = true;
    },
    addDeliverInfoHandler(addedInfo) {
      this.$emit("added", addedInfo);
      this.closeDeliveryDataSearchHandler();
    },
    closeNewPageHandler() {
      this.is_new = false;
    },

    // Edit
    startEditHandler(deliveryData) {
      this.editDeliveryData = deliveryData;
      this.is_edit = true;
    },
    editDeliveryInfoHandler(deliveryDataList) {
      this.$emit("edited", deliveryDataList);
    },
    closeEditModalHandler() {
      this.editDeliveryData = {};
      this.is_edit = false;
    },

    // Delete
    startDeleteHandler(deliveryData) {
      this.deleteDeliveryData = deliveryData;
      this.is_delete = true;
    },
    deleteDeliveryInfoHandler(deliveryDataList) {
      this.$emit("deleted", deliveryDataList);
    },
    closeDeleteModalHandler() {
      this.deleteDeliveryData = {};
      this.is_delete = false;
    }
  }
};
</script>
